import { render, staticRenderFns } from "./AddressDetail.vue?vue&type=template&id=0497c7b5&scoped=true&"
import script from "./AddressDetail.vue?vue&type=script&lang=ts&"
export * from "./AddressDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AddressDetail.vue?vue&type=style&index=0&id=0497c7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497c7b5",
  null
  
)

export default component.exports